import { useState } from "react";
import GlobalSVG from "../../utils/GlobalSVG";

const mockData = [
    { servico: "Troca de Pneus", parteVeiculo: "Plataforma", observacao: "Texto", peca: "R$ 100,00", maoDeObra: "R$ 100,00", total: "R$ 200,00" },
    { servico: "Alinhamento", parteVeiculo: "Plataforma", observacao: "Texto", peca: "R$ 100,00", maoDeObra: "R$ 100,00", total: "R$ 200,00" },
    { servico: "Balanceamento ", parteVeiculo: "Parte", observacao: "Texto", peca: "R$ 100,00", maoDeObra: "R$ 100,00", total: "R$ 200,00" },
    { servico: "Troca de Óleo", parteVeiculo: "Plataforma", observacao: "Texto", peca: "R$ 100,00", maoDeObra: "R$ 100,00", total: "R$ 200,00" },
    { servico: "Troca de Filtro de Ar do Motor", parteVeiculo: "Plataforma", observacao: "Texto", peca: "R$ 100,00", maoDeObra: "R$ 100,00", total: "R$ 200,00" },
    { servico: "Troca de Filtro de Combustível", parteVeiculo: "Plataforma", observacao: "Texto", peca: "R$ 100,00", maoDeObra: "R$ 100,00", total: "R$ 200,00" }
]

export default function OrderOfService(props) {
    const [data, setData] = useState(mockData)
    return (
        <div className="flex py-6 px-11 flex-col gap-8 items-center self-stretch bg-white rounded-sm shadow-sm max-md:px-5 max-md:max-w-full">
            <div className="flex pb-6 flex-col items-end self-stretch border-b-2 border-[#D9D9D9]">
                <div className="flex py-4 justify-between items-center self-stretch">
                    <div className="flex items-center gap-6 flex-1">
                        <div className="flex w-[100px] items-center">
                            {GlobalSVG.exampleProfile()}
                        </div>
                        <div className="flex flex-col justify-center items-start flex-1 cursor-pointer">
                            <p className="text-4xl font-medium">
                                Silva’s Oficina
                            </p>
                        </div>
                    </div>
                    <div className="flex py-1.5 px-4 justify-center items-center gap-2.5 border border-[#D9D9D9] rounded-sm">
                        {GlobalSVG.download()}
                        <p className="text-base">Baixar arquivo</p>
                    </div>
                </div>
                <div className="flex flex-col items-start gap-3 self-stretch">
                    <div className="flex items-center gap-6 self-stretch">
                        <div className="flex items-center min-w-64 p-2 gap-2 border-r rounded-sm border-b border-[#0000000F]">
                            <p className="text-base">
                                CNPJ:
                            </p>
                            <p className="text-base">
                                XX. XXX. XXX/0001-XX
                            </p>
                        </div>
                        <div className="flex items-center p-2 min-w-32 gap-2 border-r rounded-sm border-b border-[#0000000F]">
                            <p className="text-base">
                                WhatsApp:
                            </p>
                            <p className="text-base">
                                (00) 12345-6789
                            </p>
                        </div>
                        <div className="flex items-center p-2 min-w-32 gap-2 border-r rounded-sm border-b border-[#0000000F]">
                            <p className="text-base">
                                Telefone:
                            </p>
                            <p className="text-base">
                                (00) 12345-6789
                            </p>
                        </div>
                        <div className="flex items-center p-2 min-w-64 gap-2 border-r rounded-sm border-b border-[#0000000F]">
                            <p className="text-base">
                                E-mail:
                            </p>
                            <p className="text-base">
                                silvasoficina@email.com
                            </p>
                        </div>
                    </div>
                    <div className="flex items-center gap-6 self-stretch">
                        <div className="flex items-center min-w-64 p-2 gap-2 border-r rounded-sm border-b border-[#0000000F]">
                            <p className="text-base">
                                Endereço:
                            </p>
                            <p className="text-base">
                                Rua São João, 567
                            </p>
                        </div>
                        <div className="flex items-center p-2 min-w-64 gap-2 border-r rounded-sm border-b border-[#0000000F]">
                            <p className="text-base">
                                Bairro:
                            </p>
                            <p className="text-base">
                                Nova Aliança
                            </p>
                        </div>
                        <div className="flex items-center p-2 min-w-64 gap-2 border-r rounded-sm border-b border-[#0000000F]">
                            <p className="text-base">
                                Município:
                            </p>
                            <p className="text-base">
                                São Paulo - SP
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex flex-col items-end self-stretch">
                <div className="flex py-4 justify-between items-center self-stretch">
                    <p className="text-2xl font-medium flex flex-col justify-center items-start flex-1">Cliente</p>
                </div>
                <div className="flex flex-col items-start gap-3 self-stretch">
                    <div className="flex items-center gap-6 self-stretch">
                        <div className="flex items-center min-w-96 p-2 gap-2 border-r rounded-sm border-b border-[#0000000F]">
                            <p className="text-base">
                                Nome:
                            </p>
                            <p className="text-base">
                                João Antônio Silva
                            </p>
                        </div>
                        <div className="flex items-center p-2 min-w-32 gap-2 border-r rounded-sm border-b border-[#0000000F]">
                            <p className="text-base">
                                CPF:
                            </p>
                            <p className="text-base">
                                111.222.333-44
                            </p>
                        </div>
                        <div className="flex items-center p-2 min-w-32 gap-2 border-r rounded-sm border-b border-[#0000000F]">
                            <p className="text-base">
                                Telefone:
                            </p>
                            <p className="text-base">
                                (00) 99999-1111
                            </p>
                        </div>
                        <div className="flex items-center p-2 gap-2 min-w-64 border-r rounded-sm border-b border-[#0000000F]">
                            <p className="text-base">
                                E-mail:
                            </p>
                            <p className="text-base">
                                joao@email.com
                            </p>
                        </div>
                    </div>
                    <div className="flex items-center gap-6 self-stretch">
                        <div className="flex items-center min-w-32 p-2 gap-2 border-r rounded-sm border-b border-[#0000000F]">
                            <p className="text-base">
                                CEP:
                            </p>
                            <p className="text-base">
                                12345-67
                            </p>
                        </div>
                        <div className="flex items-center min-w-96 p-2 gap-2 border-r rounded-sm border-b border-[#0000000F]">
                            <p className="text-base">
                                Endereço:
                            </p>
                            <p className="text-base">
                                Rua Um Dois
                            </p>
                        </div>
                    </div>
                    <div className="flex items-center gap-6 self-stretch">
                        <div className="flex items-center min-w-32 p-2 gap-2 border-r rounded-sm border-b border-[#0000000F]">
                            <p className="text-base">
                                Nº:
                            </p>
                            <p className="text-base">
                                1234
                            </p>
                        </div>
                        <div className="flex items-center p-2  min-w-96 gap-2 border-r rounded-sm border-b border-[#0000000F]">
                            <p className="text-base">
                                Complemento:
                            </p>
                            <p className="text-base">
                                Apto 12
                            </p>
                        </div>
                        <div className="flex items-center p-2 min-w-64 gap-2 border-r rounded-sm border-b border-[#0000000F]">
                            <p className="text-base">
                                Bairro:
                            </p>
                            <p className="text-base">
                                Centro
                            </p>
                        </div>
                        <div className="flex items-center p-2 gap-2 min-w-64 border-r rounded-sm border-b border-[#0000000F]">
                            <p className="text-base">
                                Município:
                            </p>
                            <p className="text-base">
                                São Paulo - SP
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex flex-col items-end self-stretch">
                <div className="flex py-4 justify-between items-center self-stretch">
                    <p className="text-2xl font-medium flex flex-col justify-center items-start flex-1">Veículo</p>
                </div>
                <div className="flex flex-col items-start gap-3 self-stretch">
                    <div className="flex items-center gap-6 self-stretch">
                        <div className="flex items-center min-w-[500px] p-2 gap-2 border-r rounded-sm border-b border-[#0000000F]">
                            <p className="text-base">
                                Marca/Modelo:
                            </p>
                            <p className="text-base">
                                HYUNDAI/HB20 1.6M COMF
                            </p>
                        </div>
                        <div className="flex items-center p-2 min-w-32 gap-2 border-r rounded-sm border-b border-[#0000000F]">
                            <p className="text-base">
                                Ano/Modelo:
                            </p>
                            <p className="text-base">
                                2015/2015
                            </p>
                        </div>
                        <div className="flex items-center p-2 min-w-32 gap-2 border-r rounded-sm border-b border-[#0000000F]">
                            <p className="text-base">
                                Cor:
                            </p>
                            <p className="text-base">
                                Branco
                            </p>
                        </div>
                        <div className="flex items-center p-2 gap-2 min-w-64 border-r rounded-sm border-b border-[#0000000F]">
                            <p className="text-base">
                                Combustível:
                            </p>
                            <p className="text-base">
                                Álcool/Gasolina
                            </p>
                        </div>
                    </div>
                    <div className="flex items-center gap-6 self-stretch">
                        <div className="flex items-center min-w-32 p-2 gap-2 border-r rounded-sm border-b border-[#0000000F]">
                            <p className="text-base">
                                Renavam:
                            </p>
                            <p className="text-base">
                                00022233331
                            </p>
                        </div>
                        <div className="flex items-center min-w-64 p-2 gap-2 border-r rounded-sm border-b border-[#0000000F]">
                            <p className="text-base">
                                Número do Motor:
                            </p>
                            <p className="text-base">
                                0001112
                            </p>
                        </div>
                        <div className="flex items-center min-w-64 p-2 gap-2 border-r rounded-sm border-b border-[#0000000F]">
                            <p className="text-base">
                                Procedência:
                            </p>
                            <p className="text-base">
                                Nacional
                            </p>
                        </div>
                        <div className="flex items-center min-w-64 p-2 gap-2 border-r rounded-sm border-b border-[#0000000F]">
                            <p className="text-base">
                                Município:
                            </p>
                            <p className="text-base">
                                São Paulo - SP
                            </p>
                        </div>
                    </div>

                </div>
            </div>
            <div className="flex flex-col items-end self-stretch">
                <div className="flex py-4 justify-between items-center self-stretch">
                    <p className="text-2xl font-medium flex flex-col justify-center items-start flex-1">Serviços necessários</p>
                </div>
                <div className="flex flex-col items-end gap-6 self-stretch w-full">
                    <table className="min-w-full">
                        <thead>
                            <tr className="bg-[#FAFAFA] text-left font-medium divide-x border-b border-[#0000000f]">
                                <th className="px-4 py-2">Serviço</th>
                                <th className="px-4 py-2">Parte do veículo</th>
                                <th className="px-4 py-2 min-w-64">Observação</th>
                                <th className="px-4 py-2 max-w-28">Peça</th>
                                <th className="px-4 py-2 max-w-28">Mão de Obra</th>
                                <th className="px-4 py-2 max-w-28">Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.length > 0 && data.map((row) => {
                                return (
                                    <tr className="bg-white text-left border-b border-[#0000000f]">
                                        <td className=" px-4 py-2 ">{row.servico}</td>
                                        <td className=" px-4 py-2 ">{row.parteVeiculo}</td>
                                        <td className=" px-4 py-2 min-w-64 ">{row.observacao}</td>
                                        <td className=" px-4 py-2 max-w-28 ">{row.peca}</td>
                                        <td className=" px-4 py-2 max-w-28 ">{row.maoDeObra}</td>
                                        <td className=" px-4 py-2 max-w-28 ">{row.total}</td>

                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                    <div className="flex flex-col items-end gap-6">
                        <div className="flex pb-6 items-start gap-2">
                            <p className="text-base">Valor total: </p>
                            <p className="text-base font-bold">R$ 1.700,00</p>
                        </div>
                        <div className="flex pb-6 items-start gap-2">
                            <p className="text-base">Previsão de conclusão: </p>
                            <p className="text-base font-bold">30/11/2023</p>
                        </div>

                    </div>
                </div>
            </div>
            <div className="flex flex-col items-end self-stretch">
                <div className="flex py-4 justify-between items-center self-stretch">
                    <p className="text-2xl font-medium flex flex-col justify-center items-start flex-1">Informações adicionais</p>
                </div>
                <div className="flex flex-col items-start gap-6  self-stretch">
                    <div className="flex items-center gap-6 self-stretch">
                        <div className="flex items-center min-w-96 p-2 gap-2 border-r rounded-sm border-b border-[#0000000F]">
                            <p className="text-base">
                                Quilometragem:
                            </p>
                            <p className="text-base">
                                80.000 KM
                            </p>
                        </div>
                        <div className="flex items-center p-2 min-w-64 gap-2 border-r rounded-sm border-b border-[#0000000F]">
                            <p className="text-base">
                                Combustível:
                            </p>
                            <p className="text-base">
                                3/4
                            </p>
                        </div>
                    </div>
                    <div className="flex items-center gap-6 self-stretch">
                        <div className="flex items-center min-w-96 p-2 gap-2 border-r rounded-sm border-b border-[#0000000F]">
                            <p className="text-base">
                                Data de emissão da ordem:
                            </p>
                            <p className="text-base">
                                00/00/0000
                            </p>
                        </div>
                    </div>

                </div>
            </div>
            <div className="flex w-full pt-32 pb-8 items-center gap-10">
                <div className="flex pt-2.5 justify-center w-full col-6 border-t-2 border-[black]">Nome completo do cliente</div>
                <div className="flex pt-2.5 justify-center w-full col-6 border-t-2 border-[black]">Nome completo do responsável técnico</div>
            </div>
            <div className="flex px-3 py-6 h-16 w-full flex-row justify-end items-center gap-4 self-stretch">
                {/* <div className="flex h-10 w-28 px-2 py-4 justify-center items-center gap-2.5 cursor-pointer">
                    Cancelar
                </div> */}
                {/* <div className="flex h-10 w-36 px-2 py-4 justify-center items-center gap-2.5 border rounded shadow-sm  cursor-pointer">
                    Salvar rascunho
                </div> */}
                <div className="flex h-10 w-36 px-2 py-4 justify-center items-center gap-2.5 border rounded shadow-sm  cursor-pointer">
                    Editar ordem
                </div>
                <div className="flex h-10  px-2 py-4 justify-center items-center bg-[#389E0D] gap-2.5 border border-[#389E0D] rounded shadow-sm  cursor-pointer" onClick={() => props.nextStep(1)}>
                    <p className="text-[#FFF]">Incluir nova ordem de serviço</p>
                </div>
            </div>
        </div>
    );
};
